module.exports = __webpack_public_path__ + "media/images/menu-opened-d02d9773.svg";